
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { SearchData } from '@/interface/top-up-active';
import { getTopUPList, getChangeActiveStatus, getActiveDetail } from '@/api/top-up-active';
import LogUtils from 'panda-log';
import { toast } from '../../../utils/common';
import createModal from './create-modal.vue';
import { log } from 'console';

@Component({
  components: { createModal },
})
export default class ExchangeCode extends Mixins(PageQuery) {
  visible = false;
  loading = false;
  tableData = [];
  formData = {};

  query: SearchData = {
    name: '',
    creator: '',
  };

  get basicUrl() {
    return process.env.VUE_APP_BASE_API;
  }

  search() {
    this.page_query.page = 1;
    this.getCodeTable();
  }

  async openModal(id: number | undefined) {
    if (id) {
      const { code, data, msg } = await getActiveDetail({ id });
      if (code === 0) {
        this.formData = data;
      } else {
        toast(msg, 'error');
      }
    }

    this.visible = true;
  }

  async getCodeTable() {
    try {
      this.loading = true;
      const { page, page_size } = this.page_query;
      const { name = '', creator = '' } = this.query;
      const res = await getTopUPList({
        page,
        size: page_size,
        name: name.trim(),
        creator: creator.trim(),
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  /**
   * 状态切换
   */
  async switchActive(row: any) {
    const { id, enabled } = row || {};
    getChangeActiveStatus({
      id,
      enabled: !enabled,
    }).then(ret => {
      const { code, msg } = ret;
      if (code === 0) {
        toast('状态修改成功', 'success');
        this.getCodeTable();
      } else {
        toast(msg, 'error');
      }
    });
  }

  mounted() {
    this.pageFn = this.getCodeTable;
    this.getCodeTable();
  }
}
